var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrowPercentDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 0.4375L9.83594 4.5625C10.0469 4.79688 10.0469 5.14844 9.8125 5.35938C9.57812 5.57031 9.22656 5.57031 9.01562 5.33594L6.0625 2.21875V10.1875C6.0625 10.5156 5.80469 10.75 5.5 10.75C5.17188 10.75 4.9375 10.5156 4.9375 10.1875V2.21875L1.96094 5.33594C1.75 5.57031 1.39844 5.57031 1.16406 5.35938C0.929688 5.14844 0.929688 4.77344 1.14062 4.5625L5.07812 0.4375C5.19531 0.320312 5.33594 0.25 5.5 0.25C5.64062 0.25 5.78125 0.320312 5.89844 0.4375Z",
    fill: "#B3D67B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowPercentDark);
export default __webpack_public_path__ + "static/media/upArrowPercentDark.ac626008066782bed78b6a5f48ee86f8.svg";
export { ForwardRef as ReactComponent };